const HERO_IMG =
  "https://readdy.ai/api/search-image?query=editorial%20magazine%20photojournalism%20night%20city%20street%2C%20silhouetted%20figures%20walking%20past%20warm%20amber%20neon%20signage%20and%20window%20glow%2C%20cinematic%20shallow%20depth%20of%20field%2C%20gentle%20film%20grain%2C%20moody%20candid%20moment%2C%20warm%20terracotta%20and%20gold%20tones%2C%20high%20detail%2C%20artful%20composition&width=900&height=1125&seq=hero-lead-x1&orientation=portrait";

const TRAIL_LINES = [
  "签约一年整，档期表却排到三年后——头部主播合约里的「保密条款」到底封住了什么？",
  "我们顺着饭圈扒出的时间线倒推：那场所谓「临时起意」的闹剧，早在三个月前就有预告片。",
  "同一个幕后团队，为何在镜头前口径高度一致？多组消息源指向同一个沉默的答案。",
];

export default function HeroSpread() {
  return (
    <section id="headline" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        {/* kicker */}
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1 text-xs font-bold tracking-widest text-background-50">
            <i className="ri-newspaper-fill" aria-hidden="true"></i>
            今日头版
          </span>
          <span className="text-xs font-medium tracking-[0.3em] text-foreground-500">
            THE FRONT PAGE · 头条深挖
          </span>
        </div>

        {/* double spread */}
        <div className="mt-6 grid gap-10 lg:grid-cols-12 lg:gap-12">
          {/* 文 */}
          <article className="lg:col-span-6">
            <h2 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-[2.6rem] md:leading-[1.15]">
              当「圈子」开始集体沉默，
              <br className="hidden md:block" />
              成人吃瓜背后还有多少内幕没被翻出来？
            </h2>
            <p className="mt-6 border-l-4 border-accent-500 pl-4 font-heading text-lg leading-relaxed text-foreground-700 md:text-xl">
              一份不愿具名的录音、一份对不上的档期表，和一整夜刷屏的好友八卦——我们把线索摊开，试着拼出成人吃瓜圈子这一年的隐秘走向。
            </p>

            <ul className="mt-8 space-y-5">
              {TRAIL_LINES.map((line, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500/15 font-heading text-xs font-bold text-accent-800">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <p className="text-[15px] leading-relaxed text-foreground-700">{line}</p>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-col gap-3 border-t border-foreground-200/60 pt-5 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm text-foreground-500">
                撰文 <strong className="text-foreground-800">吃瓜观察员</strong> · 约 6 分钟 · 更新于 09:40
              </p>
              <a
                href="#timeline"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                追完整条线
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </article>

          {/* 图 */}
          <figure className="lg:col-span-6">
            <div className="relative">
              <div className="overflow-hidden rounded-lg border border-foreground-200/60 bg-background-100">
                <img
                  src={HERO_IMG}
                  alt="成人吃瓜圈子内幕专题配图"
                  title="成人吃瓜圈子内幕 好友八卦 行业爆料"
                  className="h-[420px] w-full object-cover object-top md:h-[560px]"
                />
              </div>
              <span className="absolute -top-2 right-6 flex items-center gap-1 rounded-full bg-background-50 px-3 py-1 text-xs font-bold tracking-widest text-primary-700 shadow-none ring-1 ring-foreground-300/50">
                <i className="ri-lock-2-line" aria-hidden="true"></i>
                付费深度 · 已解锁
              </span>
            </div>
            <figcaption className="mt-3 flex items-center justify-between gap-4 text-xs text-foreground-500">
              <span>镜头外的巷口，灯下总是有人在低头对表。</span>
              <span className="shrink-0 whitespace-nowrap">摄影 · 深夜跟拍组</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}